import * as utils from './utils';

function valEnv() {
  if (!document) {
    if (process?.env.NODE_ENV !== 'production') {
      console.error('Failed to access document object');
    }
    return false;
  }
  return true;
}

function download(fileName, context) {
  const element = window.document.createElement('a');
  element.href = utils.uri + utils.base64(utils.format(utils.template, context));
  element.download = fileName;
  document.body.appendChild(element);
  element.click();
  document.body.removeChild(element);
  return true;
}

function getTable(currentTableRef, tablePayload) {
  if (currentTableRef) {
    const cloneTable = currentTableRef.cloneNode(true);
    return cloneTable.outerHTML;
  }
  if (tablePayload) return utils.createTable(tablePayload);

  console.error('currentTableRef or tablePayload does not exist');
}

function handleDownload({ fileName, sheet, tablePayload }, currentTableRef) {
  if (!valEnv()) return false;

  const table = getTable(currentTableRef, tablePayload);
  const context = {
    worksheet: sheet || 'Worksheet',
    table,
  };

  return download(fileName, context);
}

function excel({ currentTableRef, filename, sheet }) {
  function onDownload() {
    if (!valEnv()) return false;

    const table = getTable(currentTableRef);
    const fileName = `${filename}.xls`;

    const context = {
      worksheet: sheet || 'Worksheet',
      table,
    };

    return download(fileName, context);
  }

  return { onDownload };
}

export { excel, handleDownload as downloadExcel };
